import { FC } from 'react'
import classNames from 'classnames'

type DashboardWidgetShellProps = {
  className?: string
  noPadding?: boolean
}

const DashboardWidgetShell: FC<DashboardWidgetShellProps> = ({ className, noPadding = false, children }) => {
  return (
    <section className={classNames('dashboard-widget-shell', className, { 'dashboard-widget-shell--no-padding': noPadding })}>
      <div className="dashboard-widget-shell__content">{children}</div>
    </section>
  )
}

export default DashboardWidgetShell
